<template>
  <div>
    <v-row>
      <v-col cols="12 py-0">
        <ValidationObserver ref="observer">
          <v-card>
            <v-container fluid>
              <v-row class="ma-0 align-left">
                <v-col
                  cols="12"
                  sm="6"
                  lg="6"
                  md="6"
                  class="px-0 d-flex justify-space-between"
                >
                  <v-autocomplete
                    hide-details="auto"
                    hide-no-data
                    :items="Ingredients"
                    clearable
                    outlined
                    v-model="SelectedIngredients"
                     :search-input.sync="searchIngredients"
                      :loading="getIngredientsLoading"
                    item-text="name"
                    item-value="id"
                    label="Select Types"
                    @input="SubmitData"
                  >
                  </v-autocomplete>
                </v-col>
              </v-row>

              <v-row v-if="showdatas || selectedIngredientsData">
                <v-row>
                  <v-col
                    cols="auto"
                    v-for="(SelectedIngredient,
                    index) in selectedIngredientsData"
                    :key="name"
                  >
                    <v-card
                      style="border-radius: 10px !important;"
                      width="200"
                      height="280px"
                    >
                      <v-row>
                       
                        <v-col cols="12">
                          <v-btn
                            icon
                            color="white"
                            class="closebutton"
                            @click="close(SelectedIngredient, index)"
                          >
                            <v-icon>mdi-close</v-icon>
                          </v-btn>
                          <div>
                            <v-img
                              v-if="SelectedIngredient.ingredient.image"
                              :src="SelectedIngredient.ingredient.image"
                              alt="Snow"
                              height="150px"
                              width="100%"
                            />
                            <v-img
                              v-else
                              src="../../../../assets/food.jpg"
                              alt="Snow"
                              height="150px"
                              width="100%"
                            />
                          </div>
                          <div class="head">
                            {{ SelectedIngredient.ingredient.name }}
                          </div>

                          <v-divider> </v-divider>
                        </v-col>
                        
                        <v-row>
                          <v-col cols="4" class="pl-6 py-2">
                            <!-- <v-btn icon color="green"><v-icon>mdi-minus-box</v-icon></v-btn> -->
                          </v-col>

                          <v-col cols="4" class="px-1">
                            <ValidationProvider
                              v-slot="{ errors }"
                              name="Price"
                              rules="required"
                            >
                              <v-text-field
                                outlined
                                type="number"
                                @input="SelectedIngredient.priceError = []"
                                v-model="SelectedIngredient.price"
                                :error-messages="SelectedIngredient.priceError"
                                :rules="PriceRoles"
                                 label="Price"
                                dense
                                hide-details="auto"
                                class="price-field"
                              ></v-text-field>
                            </ValidationProvider>
                          </v-col>
                          <v-col cols="4" class="px-1 py-2">
                            <!-- <v-btn icon color="green"><v-icon>mdi-plus-box</v-icon></v-btn> -->
                          </v-col>
                        </v-row>
                      </v-row>
                    </v-card>
                  </v-col>
                </v-row>
              </v-row>

              <!-- <v-row v-if="showdatas || selectedIngredientsData">
                <v-col cols="10"></v-col>
                <v-col cols="2">
                  <v-btn color="primary" @click="submit">Update</v-btn>
                </v-col>
              </v-row> -->
            </v-container>
          </v-card>
        </ValidationObserver>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import { required, email, max, regex } from "vee-validate/dist/rules";

import {
  extend,
  ValidationObserver,
  ValidationProvider,
  setInteractionMode,
} from "vee-validate";

setInteractionMode("eager");

extend("required", {
  ...required,
  message: "{_field_} is required",
});

extend("email", {
  ...email,
  message: "Email must be valid",
});

export default {
  data: () => ({
   PriceRoles: [(v) => (v && v >= 0) || "Price should be above one"],
    SelectedIngredients: null,
    selectedIngredientsData: [],
    showdatas: false,
    SelectBox: true,
    errors: [],
    messages: [],
    searchIngredients:null,
    Ingredients: [],
    getIngredientsLoading:false,
  }),
 props: {


    selectedIngredientsData: {
      type: Array,
      default: [],
    }
    
  },
  components: {
    ValidationProvider,
    ValidationObserver,
  },
  created() {
    this.GetIngredients();
  },
  watch: {
    searchIngredients(value) {
      
      if (!value) {
        this.GetIngredients("");
      }

      this.GetIngredients(value);
    },
  },

  methods: {
    GetIngredients(query = "") {
      
     this.getIngredientsLoading = true;
       let except=[]
      this.selectedIngredientsData.map(p=>{
          except.push(p.ingredient.id)
      })
      
      this.$store
        .dispatch("ingredients/GetIngredients", {
           query: query.searchQuery,
          except:except
        })
        .then((res) => {
          console.log(res);
          this.Ingredients = res.data.data;
         this.getIngredientsLoading =false
        })
        .catch((err) => {});
    },
    async submit() {
      ;
      const isValid = await this.$refs.observer.validate();
      let error = false;
      this.selectedIngredientsData.map((p) => {
        if (!p.price || p.price <= 0) {
          p.priceError = [];
          error = true;
          p.priceError.push("price is required");
        }
      });
       var temp=this.selectedIngredientsData
      this.selectedIngredientsData=[]
      this.selectedIngredientsData=temp
      if (isValid && !error) {
        const ingredients = this.selectedIngredientsData.map((item) => ({
          ingredient_id: item.ingredient ? item.ingredient.id : item.id,
          price: Number(item.price),
        }));
        this.$emit("save", ingredients);
      }
    },
   

    close(selectdata, index) {
      if (selectdata) {
        this.selectedIngredientsData.splice(index, 1);
      }
      this.GetIngredients()
    },
    GetDatasIngredients() {
   
      return this.selectedIngredientsData;
      
    },
    SubmitData() {
     
      this.showdatas = true;
      let selected = this.Ingredients.find(
        (p) => p.id == this.SelectedIngredients
      );
      if (selected) {
        this.selectedIngredientsData.push({ingredient:selected});
      }
      this.GetIngredients()
    },
  },
};
</script>
<style>
.price {
  margin-top: -15px;
  margin-left: 68px;
}
.head {
  text-align: center;
  text-overflow: inherit;
  font-size: 13px;
  font-weight: 750;
  background: whitesmoke;
}

.TypeImage {
  width: 100%;
  background-image: url("../../../../assets/food.jpg");
  /* background-image: url("https://cdn.pixabay.com/photo/2015/04/23/22/00/tree-736885__340.jpg"); */
}
.pricetag {
  font-size: 13px;
  font-weight: 800;
  text-align: center;
  margin-left: 98px;
}
.closebutton {
 position: absolute !important;
  top: 4px;
  right: -7px;
   background: rgba(0, 0, 0, 0.7) !important;
  border-radius: 25% !important;
  padding: 5px !important;
  /* z-index: 10; */
  min-width: 30px !important;
  height: 30px !important;
}
</style>
